import { FC, useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Box } from '@mui/material';
import { Dayjs } from 'dayjs';

interface CustomDatetimepickerProps {
  label?: string;
  initialValue?: Dayjs | null;
  handleValueChange?: (value: Dayjs | null) => void;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  onBlur?: () => void;
}

const CustomDatetimepicker: FC<CustomDatetimepickerProps> = ({
  label,
  initialValue = null,
  handleValueChange,
  required = false,
  error = false,
  errorMessage = '',
  onBlur,
}) => {
  const [value, setValue] = useState<Dayjs | null>(initialValue);

  useEffect(() => {
    if (initialValue === value) return;

    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (newValue: Dayjs | null) => {
    setValue(newValue);
    if (handleValueChange) {
      handleValueChange(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <DateTimePicker
          label={label}
          value={value}
          onChange={handleChange}
          timeSteps={{ minutes: 1 }}
          sx={{
            width: '100%',
          }}
          slotProps={{
            textField: {
              required: required,
              error: error,
              helperText: errorMessage,
              onBlur: onBlur,
            },
            popper: {
              sx: {
                zIndex: 10000,
              },
            },
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomDatetimepicker;
